// removed by extract-text-webpack-plugin
module.exports = {"notification":"_3y1fLq5","miniBag":"_13bi4_K","link":"_11qZWTX","spinnerContainer":"_26s4UbK","error":"wm-Y41N"};


//////////////////
// WEBPACK FOOTER
// ./template/components/MiniBag/index.css
// module id = ./template/components/MiniBag/index.css
// module chunks = client.sitechrome